import Settings from 'components/organisms/Profile/Settings';
import noop from 'helper/noop';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as settingsAC, getSettings } from 'store/settings';

const mapStateToProps = (state, ownProps) => {
	const settings = getSettings(state);

	return {
		settings,
		signature: Object.keys(settings)
			.map((setting: string) => {
				return `${setting}-${settings[setting] ? 1 : 0}`;
			})
			.join('|'),
		onSettingChanged: ownProps.onSettingChanged || noop,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doUpdateSettings: settingsAC.doUpdateSettings,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings as any);
